// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__1aLfU","lastUpdated":"PrivacyPolicy_lastUpdated__3bh3R"};